import React from 'react';
import { Header, Responsive, Segment, Tab } from 'semantic-ui-react';
import axios from 'axios';
import DetailsEng from './DetailsEng';
import DetailsBHS from './DetailsBHS';
import { fetchAllAcademicYears, fetchFaculties, fetchLanguages, fetchStudyCycle, fetchTitles } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class Details extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationalUnits: [],
            studyCycles: [],
            allLanguages: [],
            academicYears: [],
            titles: []
        };
    }


    componentDidMount() {
        axios.all([fetchFaculties(), fetchStudyCycle(), fetchLanguages(), fetchAllAcademicYears(), fetchTitles()])
            .then(axios.spread((orgUnitsRes, studyCycleRes, languageRes, academicYearsRes, titlesRes) => {
                const organizationalUnits = orgUnitsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));
                const studyCycles = studyCycleRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));
                const allLanguages = languageRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));
                const academicYears = academicYearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                })).reverse();

                const titles = titlesRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));

                this.setState({
                    organizationalUnits, studyCycles, allLanguages, academicYears, titles
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch organizationalUnits, studyCycles, languages or academicYears');
            });
    }

    render() {
        const { implementation } = JSON.parse(localStorage.getItem('implementation'));
        const {
            organizationalUnits, studyCycles, allLanguages, academicYears
        } = this.state;

        const panes = [
            {
                menuItem: 'Bosanski / hrvatski / srpski jezik',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <DetailsBHS
                        organizationalUnits={organizationalUnits}
                        studyCycles={studyCycles}
                        allLanguages={allLanguages}
                        academicYears={academicYears}
                        implementation={JSON.parse(localStorage.getItem('implementation'))}
                        titles={this.state.titles}
                    />
                </Tab.Pane>)
            },
            {
                menuItem: 'Engleski jezik',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <DetailsEng
                        organizationalUnits={organizationalUnits}
                        studyCycles={studyCycles}
                        allLanguages={allLanguages}
                        academicYears={academicYears}
                        implementation={JSON.parse(localStorage.getItem('implementation'))}
                    />
                </Tab.Pane>)
            },
        ];


        return (
            <div>
                {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' ) ? <Header as="h1">Detalji izmjene implementacije</Header> : <Header as="h1">Detalji implementacije</Header>}

                <Segment.Group raised>
                    <Segment clearing>
                        <Header>
                            <Header as="h3" >
                                <Header.Content>
                                Implementacija studijskog programa: {JSON.parse(localStorage.getItem('implementation')).studyProgram.name}
                                </Header.Content>
                                <Header.Subheader>
                                   {localStorage.getItem('basicName')}
                                </Header.Subheader>
                            </Header>
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} />

                    </Segment>
                </Segment.Group >
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/Details.js